import z, { ZodType } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';
import { EntityWithTitle, entityWithTitleSchema } from './entity-with-title';

export type DeviceDetailed = {
	id: number;
	name: string;
	account: EntityWithName;
	cashdesk: EntityWithName;
	game: EntityWithTitle;
	currency: string;
	cashdeskCode: string;
	players: string;
	isActive: boolean;
};

export const deviceDetailedSchema: ZodType<DeviceDetailed> = z.object({
	id: z.number(),
	name: z.string(),
	account: entityWithNameSchema,
	cashdesk: entityWithNameSchema,
	game: entityWithTitleSchema,
	currency: z.string(),
	cashdeskCode: z.string(),
	players: z.string(),
	isActive: z.boolean(),
});
